var YMK = YMK || {};
var site = site || {};
var prodcat = prodcat || {};

(function ($) {
  Drupal.behaviors.productVtoV1 = {
    attach: function (context) {
      var $productVTO = $('.js-product-vto-v1', context);

      if (!$productVTO.length) {
        return;
      }
      var autoTriggerYoucam = window.location.href.indexOf('vto_open') !== -1;
      var hasVtoDiscloseParam = window.location.href.indexOf('vto_disclose') !== -1;
      var hasVtoDisPriceParam = window.location.href.indexOf('vto_disprice') !== -1;
      var showCloseBtn = hasVtoDiscloseParam ? false : true;
      var $youcamButton = $('.js-youcambtn', $productVTO);
      var $ymkModuleCont = $('.js-product-vto-container', $productVTO);
      var $mobileShadePick = $('.js-product-vto-mobile-ctrl', $productVTO);
      var $addToBagContainer = $('.js-product-vto-cart', $productVTO);
      var $addToBag = $('.js-add-to-cart', $productVTO);
      var $priceContainer = $('.js-product-price', $productVTO);
      var currentSkuBaseId = $('.js-product-full', context).attr('data-sku-base-id');
      var $productImages = $productVTO.closest('.product-full__media');
      var $body = $('body');
      var youcamAPIKey = Drupal.settings.vto.api_key;
      var youcamAPIUrl = Drupal.settings.vto.api_url;
      var language = Drupal.settings.vto.language;
      var currentBpWidth = parseInt(Unison.fetch.now().width, 10);
      var bPlargeUp = parseInt(Unison.fetch.all()['medium'], 10);
      var isMobile = currentBpWidth < bPlargeUp;
      var youcamEvents = [
        'cameraClosed',
        'cameraFailed',
        'cameraOpened',
        'chooseModel',
        'compare',
        'compareDisabled',
        'closed',
        'engineClosed',
        'loaded',
        'loading',
        'kissDetected',
        'opened',
        'photoLoaded',
        'photoSaved',
        'reset',
        'videoLoaded',
        'shadeFinderStarted',
        'shadeFinderComplete',
        'shadeFinderCancelled',
        'shareByEmailResult',
        'zoom',
        'modelLoaded',
        'skinAnalysisUpdated',
        'split4Way',
        'split4WayDisabled'
      ];
      var ykmWidth;
      var ykmHeight;
      var currentSkuPcode;

      (function (d, k) {
        var s = d.createElement('script');

        s.type = 'text/javascript';
        s.async = true;
        s.src = youcamAPIUrl + k;
        var x = d.getElementsByTagName('script')[0];

        x.parentNode.insertBefore(s, x);
      })(document, youcamAPIKey);

      Unison.on('change', function () {
        var isModuleLoaded = $productVTO.find('#YMK-module-iframe').length;
        var isModuleVisible = $productVTO.find('.js-product-vto-container').is(':visible');
        var $chatLiveButton = $('.LPMcontainer');

        currentBpWidth = parseInt(Unison.fetch.now().width, 10);
        isMobile = currentBpWidth < bPlargeUp;
        if (typeof window.YMK.close === 'function' && isModuleLoaded && isModuleVisible) {
          window.YMK.closeEngine();
          window.YMK.close();
          $ymkModuleCont.removeClass('hidden');
          $productImages.addClass('vto-active');
          window.ymkAsyncInit(true);
        }
        if (!isMobile) {
          ykmWidth = $productImages.find('.js-product-full-image-main').width();
          ykmWidth = ykmWidth > 700 ? 600 : ykmWidth;
          $productVTO.width(ykmWidth);
        } else {
          $chatLiveButton.removeClass('hidden');
        }
      });

      window.ymkAsyncInit = function (skipEventListener) {
        var skuData;
        var vtoParams;

        if (typeof window.YMK.init !== 'undefined') {
          if (isMobile) {
            $ymkModuleCont.height($(window).height());
            vtoParams = {
              autoOpen: true,
              skinSmoothStrength: 50,
              showCloseBtnOnLauncher: showCloseBtn
            };
            if (language) {
              vtoParams['language'] = language;
            }
            window.YMK.init(vtoParams);
          } else {
            ykmWidth = $productImages.find('.js-product-full-image-main').width();
            ykmWidth = ykmWidth > 700 ? 600 : ykmWidth;
            // Width and height ratio should be 1:1.22
            ykmHeight = 1.22 * ykmWidth;
            $ymkModuleCont.height('auto');
            $productVTO.width(ykmWidth);
            vtoParams = {
              autoOpen: true,
              skinSmoothStrength: 50,
              showCloseBtnOnLauncher: showCloseBtn,
              width: ykmWidth,
              height: ykmHeight
            };
            if (language) {
              vtoParams['language'] = language;
            }
            window.YMK.init(vtoParams);
          }
        }
        if (skipEventListener) {
          return;
        }
        youcamEvents.forEach(function (event) {
          window.YMK.addEventListener(event, function (progress) {
            if (event === 'opened') {
              if (!$ymkModuleCont.hasClass('hidden')) {
                $productImages.addClass('vto-active');
              }
            }
            if (event === 'loaded') {
              skuData = prodcat.data.getSku(currentSkuBaseId);
              currentSkuPcode = skuData.PRODUCT_CODE;
              YMK.applyMakeupBySku(currentSkuPcode);
              hideVtoPrice();
              if (isMobile) {
                $mobileShadePick.removeClass('hidden');
                $productVTO.trigger('resize');
                $productVTO.trigger('productVTO:loaded');
                $('.js-product-full', context).trigger('product.skuSelect', currentSkuBaseId);
              }
            }

            if (event === 'closed') {
              var $chatLiveButton = $('.LPMcontainer');

              skuData = prodcat.data.getSku(currentSkuBaseId);
              if (isMobile) {
                $mobileShadePick.addClass('hidden');
                $chatLiveButton.removeClass('hidden');
              }
              if (skuData.VTO_FLAG_ONLINE) {
                $youcamButton.removeClass('disabled');
              }
              $ymkModuleCont.addClass('hidden');
              $productImages.removeClass('vto-active');
              $body.removeClass('no-scroll');
              window.YMK.closeEngine();
              if (hasVtoDiscloseParam) {
                openYoucamModule();
              }
            }
            // MTA-2589 - Analytics tagging for YouCam events - Starts
            if (site && site.track) {
              var productName, eventName;
              var data = site.track.refreshData();

              if (data && data.product_name && data.product_name.length) {
                productName = data.product_name[0].replace(/(<([^>]+)>)/gi, '');
              }
              // Supressing multiple event tag fires during loading youcam event
              if (event === 'loading') {
                if (progress === 10) {
                  eventName = 'loading-start';
                } else if (progress === 100) {
                  eventName = 'loading-complete';
                }
              } else {
                eventName = event;
              }
              if (eventName && eventName !== '') {
                site.track.evtLink({
                  event_name: 'vto',
                  event_category: 'youcam',
                  event_action: eventName,
                  event_label: 'SKU' + currentSkuBaseId + ' - ' + productName
                });
              }
            }
            // MTA-2589 - Analytics tagging for YouCam events - Ends
          });
        });
      };

      function openYoucamModule() {
        var $chatLiveButton = $('.LPMcontainer');

        if (!autoTriggerYoucam && !hasVtoDiscloseParam) {
          window.YMK.closeEngine();
          window.YMK.close();
        }
        $youcamButton.addClass('disabled');
        $ymkModuleCont.removeClass('hidden');
        autoTriggerYoucam = 0;
        if (isMobile) {
          // Disable scrolling
          $chatLiveButton.addClass('hidden');
          window.scrollTo(0, 0);
          $body.addClass('no-scroll');
        }
        window.ymkAsyncInit(true);
      }

      function hideVtoPrice() {
        var isRetailer = $body.hasClass('is-retailer');

        // vto_disprice & addtobag=0 should work together. Hide the price and addtobag should remain consistent.
        if (hasVtoDisPriceParam && isRetailer && !$.cookie('vto_disprice')) {
          $.cookie('vto_disprice', '1', { path: '/' });
          $priceContainer.addClass('hidden');
        } else if ($.cookie('vto_disprice') && isRetailer) {
          $priceContainer.addClass('hidden');
        } else if ($.cookie('vto_disprice') && !isRetailer) {
          $.cookie('vto_disprice', null, { path: '/' });
        }
      }

      $youcamButton.once().on('click', function (e) {
        e.preventDefault();
        openYoucamModule();
      });

      $(document).on('product.skuSelect', '.js-product-full', function (e, skuBaseId) {
        // Update shadename
        var skuData = prodcat.data.getSku(skuBaseId);
        var $shadeSwatch = $('.js-product-vto-shade-name', $mobileShadePick);
        var $shadeColor = $('.js-product-vto-shade-color', $mobileShadePick);
        var $shadeDescription = $('.js-product-vto-shade-description', $mobileShadePick);

        currentSkuBaseId = skuData.SKU_BASE_ID;

        // Update mobile swatches
        $shadeSwatch.text(skuData.SHADENAME);
        $shadeColor.css('background-color', skuData.HEX_VALUE_STRING);
        $shadeDescription.text(skuData.SHADE_DESCRIPTION);

        // Change the shade
        currentSkuPcode = skuData.PRODUCT_CODE;
        if (YMK) {
          YMK.applyMakeupBySku(currentSkuPcode);
        }

        // Enable/disable the button
        if (skuData.VTO_FLAG_ONLINE) {
          $youcamButton.removeClass('disabled');
        } else {
          $youcamButton.addClass('disabled');
        }
      });

      $(document).bind('addToCart.success', function () {
        var addedText = $addToBagContainer.data('added-text');
        var atbText = $addToBag.html();

        if (atbText !== addedText) {
          $addToBag.html(addedText);
          setTimeout(function () {
            $addToBag.html(atbText);
          }, 3000);
        }
      });

      if (autoTriggerYoucam) {
        openYoucamModule();
      }
    }
  };

  $(document).on('product.skuSelect', '.js-product-full', function (e, skuBaseId) {
    var $youcamButton = $('.js-youcambtn', $(this));
    var skuData = prodcat.data.getSku(skuBaseId);

    if (skuData.VTO_FLAG_ONLINE) {
      $youcamButton.removeClass('disabled');
    } else {
      $youcamButton.addClass('disabled');
    }
  });
})(jQuery);
